<section class="content-header" style="padding:5px !important">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item"><a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Sổ lên lớp &nbsp;</li>
                    <div class="{{TitleClass}}"></div>
                </ol>
            </div>
            <!-- <div class="col-md-6">
                <button (click)="help()" class="btn btn-warning btn-sm" type="submit" style="float: right; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div> -->

        </div><!-- /.row -->
    </div><!-- /.container-fluid -->
</section>

<section class="content cus-body" *ngIf="isDisplay">
    <div class="card">
        <div class="card-body" style="padding: 0px 20px 0px 20px;">
            <div class="tab-content">
                <div class="active tab-pane">
                    <div class="row">
                        <div class="col-md-4">
                            <label class="col-md-10">Năm học</label>
                            <select (change)="getList()" class="form-control" [(ngModel)]="Nam_hoc_fil">
                                <option value="">Tất cả</option>
                                <option *ngFor="let p of Nam_hoc_arr" value="{{p.value}}">{{p.name}}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-10">Học kỳ</label>
                            <select (change)="getList()" class="form-control" [(ngModel)]="Hoc_ky_fil">
                                <option value="0">Tất cả</option>
                                <option value="1">Học kỳ 1</option>
                                <option value="2">Học kỳ 2</option>
                            </select>
                        </div>
                        <!-- <div class="col-md-4">
                            <label class="col-md-10">Tên lớp</label>
                            <input (change)="getList()" class="form-control" type="text" placeholder="Nhập tên lớp"
                                [(ngModel)]="Ten_lop_fil">
                        </div> -->
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Lớp</label>
                            <ng-select (change)="getList()" [(ngModel)]="Ten_lop_fil" placeholder="Chọn lớp">
                                <ng-option [value]="''">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listClass" [value]="item.Ten_lop">{{item.Ten_lop}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom: 1%;">
                        <div class="col-md-4">
                            <label class="col-md-10">Tên môn</label>
                            <input (change)="getList()" class="form-control" type="text" placeholder="Nhập tên môn"
                                [(ngModel)]="Ten_mon_fil">
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-10">Giảng viên/Mã tên</label>
                            <ng-select (change)="getList()" placeholder="Chọn mã/tên giảng viên"  [(ngModel)]="Giang_vien_fil">
                                <ng-option [value]="''">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listTeacher" [value]="item.Ma_cb">{{item.Ma_cb}} - {{item.Ho_ten}}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-10">Bộ môn</label>
                            <ng-select (change)="getList()" placeholder="Chọn bộ môn" [(ngModel)]="Bo_mon_fil">
                                <ng-option [value]="0">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listSubject" [value]="item.ID_bm">{{item.Bo_mon}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="tab-content">
                <div class="active tab-pane" id="TeachInfo">
                    <div class="row">
                        <div class="col-md-6">
                            Hiển thị
                            <select (change)="handlePageSizeChange($event)">
                                <option *ngFor="let size of pageSizes" [ngValue]="size">
                                    {{ size }}
                                </option>
                            </select>
                            kết quả
                        </div>
                        <div class="col-md-6">
                            <button title="Ẩn/hiện bộ lọc" style="float: right; margin: 0 0 5px 5px"
                                (click)="buttonFilter()">
                                <i class="fas fa-filter"></i>
                            </button>
                            <button title="Tải lại" style="float: right; margin-bottom: 5px" (click)="refesh()">
                                <i class="fas fa-redo-alt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <!-- /.col -->
                        <div class="col-md-12">
                            <!-- <div class="table-responsive dataTables_wrapper container-fluid dt-bootstrap4 cus-fs">
                                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                    class=" table-bordered dataTables_wrapper no-footer">
                                    <thead> -->
                            <div class="table-responsive" style="max-height: 60vh; margin-bottom: 15px;">
                                <table class="table table-bordered dataTable">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Tên môn</th>
                                            <th>Tên lớp</th>
                                            <th>Học kỳ</th>
                                            <th>Năm học</th>
                                            <th>Ký hiệu</th>
                                            <th>Số sinh viên</th>
                                            <th>Mã cán bộ</th>
                                            <th>Tên giảng viên</th>
                                            <th>Thao tác</th>
                                            <!-- <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- <tr
                                            *ngFor="let p of ClassData | tableFilter: Nam_hoc_fil | FilterClass:{Ten_mon : Ten_mon_fil , Ten_lop : Ten_lop_fil }"> -->

                                            <tr *ngFor="let p of ClassData; let i = index">
                                            <td>{{ i + 1}}</td>
                                            <td>{{ p.Ten_mon }}</td>
                                            <td>{{ p.Ten_lop }}</td>
                                            <td>{{ p.Hoc_ky }}</td>
                                            <td>{{ p.Nam_hoc }}</td>
                                            <td>{{ p.Ky_hieu }}</td>
                                            <td>{{ p.So_sv }}</td>
                                            <td>{{ p.Ma_cb }}</td>
                                            <td>{{ p.Ho_ten }}</td>
                                            <td>
                                                <a style="margin-right: 5px;" [routerLink]="['/notebook']" target="_blank"
                                                    [queryParams]="{CategoryID: p.Loai_lop,ID:p.ID_lop,ID_cb:p.ID_cb,Ten_lop:p.Ten_lop,Ten_mon:p.Ten_mon,ID_mon:p.ID_mon,Hoc_ky:p.Hoc_ky,Nam_hoc:p.Nam_hoc}"
                                                    queryParamsHandling="merge">
                                                    Xem chi tiết
                                                </a>
                                            </td>
                                        </tr>

                                        <tr *ngIf="ClassData.length == 0">
                                            <td colspan="16" class="text-center">Không có kết quả</td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <!-- <p style="float: left; font-weight: bold">
                                    Tổng số {{ totalItem | number }} kết quả, đã lọc được
                                    {{ totalItemFilter | number }} kết quả
                                  </p> -->
                                    <p style="float: left; font-weight: bold">
                                        Đã lọc được {{ totalItemFilter | number }} kết quả
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <nav aria-label="Page navigation example" style="float: right">
                                        <ul class="pagination">
                                            <li class="page-item" [class.disabled]="page == 1">
                                                <a class="page-link" (click)="changePage(1)">Đầu</a>
                                            </li>
                                            <li class="page-item" [class.disabled]="page == 1">
                                                <a class="page-link" (click)="changePage('pre')">Trước</a>
                                            </li>
                                            <ng-container *ngIf="page > 4">
                                                <li class="page-item"><a class="page-link">...</a></li>
                                            </ng-container>
                                            <ng-container *ngFor="let element of arrNumberPage_chil">
                                                <li class="page-item" [class.active]="page == element">
                                                    <a class="page-link" (click)="changePage(element)">{{
                                                        element
                                                        }}</a>
                                                </li>
                                            </ng-container>
                                            <ng-container *ngIf="page < numberPage - 4">
                                                <li class="page-item"><a class="page-link">...</a></li>
                                            </ng-container>
                                            <li class="page-item" [class.disabled]="page == numberPage">
                                                <a class="page-link" (click)="changePage('next')">Sau</a>
                                            </li>
                                            <li class="page-item" [class.disabled]="page == numberPage">
                                                <a class="page-link" (click)="changePage(numberPage)">Cuối</a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <!-- /.col -->
                    </div>
                </div>
            </div>
            <!-- /.tab-content -->
        </div><!-- /.card-body -->
    </div>

    <!-- /.row -->
</section>
<!-- /.content -->